<template>
  <div class="form-group discussion-box">
    <slot>
    <span class="form-group">
      <label>
        {{title}}
      </label>
      <comments :field-name="commentsField"></comments>
    </span>
    </slot>

    <div class="alert alert-info">
      <strong>Discussion Points:</strong> {{points}}
    </div>
  </div>
</template>

<script>
import Comments from '@/components/Comments'

export default {
  name: 'DiscussionPoints',
  components: { Comments, },
  props: ['points', 'comments-field', 'title'],
}
</script>
<style>
.discussion-box {
  border: 1px solid rgba(0,0,0, 0.2);
  border-radius: 4px;
  padding-top: 15px;
}
.discussion-box .alert {
  margin-top: 15px;
  margin-bottom: 0;
}
</style>
